// extracted by mini-css-extract-plugin
export default {"reportNameWithLink":"ReportNameWithLink_reportNameWithLink__8taQ1","box":"ReportNameWithLink_box__aquSC"};